import axios from 'axios'
import { cautionUrl } from '@/api/config'
import { errorCollection } from '@/api/dmp/dmpCollection'

// // 获取websocket连接加密信息
export function connectMessage(params) {
  const url = cautionUrl + '/websocket/connect/message'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('实时监控', '获取websocket连接加密信息', res)
    }
    return Promise.resolve(res.data)
  })
}
